module.exports = __webpack_public_path__ + "media/images/icons/next-white-3a9fa71f05275b0d5273f48cc46a6af4.svg";